// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Search_Tabs__1ocen","TabButton":"Search_TabButton__XWs6O"};